/**
 * Substack Newsletter Embed Component
 *
 * Integrates Aspexit's Substack newsletter using the official embed method.
 * URL: https://aspexit.substack.com
 */

interface SubstackEmbedProps {
  /** Display mode: 'inline' for footer, 'popup' for modal (future) */
  mode?: 'inline' | 'popup';
  /** Custom placeholder text */
  placeholder?: string;
  /** Custom button text */
  buttonText?: string;
  /** Show compact version (smaller) */
  compact?: boolean;
}

export function SubstackEmbed({
  mode = 'inline',
  placeholder = 'Votre email',
  buttonText = 'S\'inscrire',
  compact = true
}: SubstackEmbedProps) {

  // Substack publication URL
  const substackUrl = 'https://corentinleroux.substack.com';

  return (
    <div className="substack-embed-wrapper">
      <iframe
        src={`${substackUrl}/embed`}
        width="100%"
        height={compact ? '60' : '150'}
        style={{
          border: 'none',
          background: 'transparent',
        }}
        frameBorder="0"
        scrolling="no"
        title="Newsletter Aspexit"
        loading="lazy"
      />

      {/* Custom styling to override Substack defaults */}
      <style>{`
        .substack-embed-wrapper iframe {
          background: transparent !important;
        }

        /* Override Substack styles to match our design */
        .substack-embed-wrapper iframe::after {
          background: transparent !important;
        }
      `}</style>
    </div>
  );
}

/**
 * Alternative: Custom form that posts to Substack
 * Use this if the iframe doesn't match the design
 */
export function SubstackCustomForm({
  placeholder = 'Votre email',
  buttonText = 'S\'inscrire',
}: Pick<SubstackEmbedProps, 'placeholder' | 'buttonText'>) {

  const substackUrl = 'https://corentinleroux.substack.com';

  return (
    <form
      action={`${substackUrl}/api/v1/free?nojs=true`}
      method="post"
      className="flex gap-2"
      target="_blank"
    >
      <input
        type="email"
        name="email"
        placeholder={placeholder}
        required
        className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aspexit-green"
      />
      <button
        type="submit"
        className="px-4 py-2 bg-aspexit-green text-white font-medium rounded hover:bg-aspexit-green-dark transition-colors text-sm whitespace-nowrap"
      >
        {buttonText}
      </button>

      {/* Hidden fields for Substack */}
      <input type="hidden" name="nojs" value="true" />
    </form>
  );
}
